import React from 'react';

import { CircleWithCheckIcon, InfoIcon, WarningIcon } from '@modernloop/shared/icons';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { CustomContentProps } from 'notistack';

export type ToastProps = CustomContentProps;

const Toast: React.ForwardRefRenderFunction<HTMLDivElement, ToastProps> = (props, ref) => {
  const theme = useTheme();
  const { variant, message } = props;

  const getIcon = () => {
    switch (variant) {
      case 'success':
        return <CircleWithCheckIcon color="success" />;
      case 'error':
        return <WarningIcon color="error" />;
      case 'warning':
        return <WarningIcon color="warning" />;
      case 'info':
        return <InfoIcon color="info" />;
      default:
        return null;
    }
  };

  const getHighlight = () => {
    switch (variant) {
      case 'error':
        return (
          <Box height="4px" left="0px" top="0px" bgcolor={theme.palette.error.main} position="absolute" width="100%" />
        );
      case 'success':
        return (
          <Box
            height="4px"
            left="0px"
            top="0px"
            bgcolor={theme.palette.success.main}
            position="absolute"
            width="100%"
          />
        );
      default:
        return null;
    }
  };

  return (
    <Box
      component="div"
      p="12px"
      maxWidth="fit-content"
      borderRadius="6px"
      ref={ref}
      bgcolor={theme.palette.background.default}
      style={{
        boxShadow: theme.shadows[2],
        position: 'relative',
        overflow: 'hidden',
        outline: `1px solid ${theme.palette.borderState.default}`,
        outlineOffset: '-1px',
      }}
    >
      {getHighlight()}
      <Stack direction="row" spacing={0.5} alignItems="center">
        {getIcon()}
        <Typography>{message}</Typography>
      </Stack>
    </Box>
  );
};

export default React.forwardRef<HTMLDivElement, ToastProps>(Toast);
